import React from 'react';
import { Row, Col, Container} from 'reactstrap';
import {Link} from 'react-router';
import urlBase from '../../url-base';
import Dialog from 'material-ui/Dialog';


class EveryCompany extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modal1:false,
      modal2:false,
      modal3:false,
      modal4:false,
      modal5:false,
      modal6:false,
    };

    this.styles = {
      
    };
  }
  modalOn1(){
    let state = this.state;
    state.modal1 = true;
    this.setState(state);
  }
  modalOn2(){
    let state = this.state;
    state.modal2 = true;
    this.setState(state);
  }
  modalOn3(){
    let state = this.state;
    state.modal3 = true;
    this.setState(state);
  }
  modalOn4(){
    let state = this.state;
    state.modal4 = true;
    this.setState(state);
  }
  modalOn5(){
    let state = this.state;
    state.modal5 = true;
    this.setState(state);
  }
  modalOn6(){
    let state = this.state;
    state.modal6 = true;
    this.setState(state);
  }
  modalOff1(){
    let state = this.state;
    state.modal1 = false;
    this.setState(state);
  }
  modalOff2(){
    let state = this.state;
    state.modal2 = false;
    this.setState(state);
  }
  modalOff3(){
    let state = this.state;
    state.modal3 = false;
    this.setState(state);
  }
  modalOff4(){
    let state = this.state;
    state.modal4 = false;
    this.setState(state);
  }
  modalOff5(){
    let state = this.state;
    state.modal5 = false;
    this.setState(state);
  }
  modalOff6(){
    let state = this.state;
    state.modal6 = false;
    this.setState(state);
  }
  overOn(id){
    document.getElementById(id).src = urlBase.client+"assets/images2/icons/ilustras/"+id+"-ativo.png";
  }
  overOff(id){
    document.getElementById(id).src = urlBase.client+"assets/images2/icons/ilustras/"+id+".png";
  }
  render() {

    return (
      <div id="component_every_company">
        <Container >
          <hr className="hr_style"/>
          <div className="layout_img"> 
            {''}
          </div>
          <p className="text_every">
            Conheça, consulte um corretor e <br/>
            faça o orçamento da sua empresa
          </p>
          <div className="every_icons">
            <Row>
              <Col onMouseOver={this.overOn.bind(this, "hora-marcada")} onMouseOut={this.overOff.bind(this, "hora-marcada")} onClick={this.modalOn1.bind(this)} style={{cursor:'pointer'}} xs="12" sm="6" md="4" lg="4" xl="4">
                <img id="hora-marcada"  src={urlBase.client+"assets/images2/icons/ilustras/hora-marcada.png"} />
                <p className="text_icon">DENTISTAS COM <br/> HORA MARCADA</p>
              </Col>
              <Col onMouseOver={this.overOn.bind(this, "liberacao")} onMouseOut={this.overOff.bind(this, "liberacao")} onClick={this.modalOn2.bind(this)} style={{cursor:'pointer'}} xs="12" sm="6" md="4" lg="4" xl="4">
                <img id="liberacao" src={urlBase.client+"assets/images2/icons/ilustras/liberacao.png"} />
                <p className="text_icon">LIBERAÇÃO DE <br/> PROCEDIMENTOS <br/> VIA INTERNET</p>
              </Col>
              <Col onMouseOver={this.overOn.bind(this, "materiais")} onMouseOut={this.overOff.bind(this, "materiais")} onClick={this.modalOn3.bind(this)} style={{cursor:'pointer'}} xs="12" sm="6" md="4" lg="4" xl="4">
                <img id="materiais" src={urlBase.client+"assets/images2/icons/ilustras/materiais.png"} />
                <p className="text_icon">MATERIAIS DE <br/> QUALIDADE <br/> INTERNACIONAL</p>
              </Col>
              <Col onMouseOver={this.overOn.bind(this, "gerente")} onMouseOut={this.overOff.bind(this, "gerente")} onClick={this.modalOn4.bind(this)} style={{cursor:'pointer'}} xs="12" sm="6" md="4" lg="4" xl="4">
                <img id="gerente" src={urlBase.client+"assets/images2/icons/ilustras/gerente.png"} />
                <p className="text_icon">GERENTE DE CONTAS<br/> EMPRESARIAIS</p>
              </Col>
              <Col onMouseOver={this.overOn.bind(this, "gestao")} onMouseOut={this.overOff.bind(this, "gestao")} onClick={this.modalOn5.bind(this)} style={{cursor:'pointer'}} xs="12" sm="6" md="4" lg="4" xl="4">
                <img id="gestao" src={urlBase.client+"assets/images2/icons/ilustras/gestao.png"} />
                <p className="text_icon">GESTÃO DO<br/> BENEFÍCIO<br/> 100% ONLINE</p>
              </Col>
              <Col onMouseOver={this.overOn.bind(this, "odontomovel")} onMouseOut={this.overOff.bind(this, "odontomovel")} onClick={this.modalOn6.bind(this)} style={{cursor:'pointer'}} xs="12" sm="6" md="4" lg="4" xl="4">
                <img id="odontomovel" src={urlBase.client+"assets/images2/icons/ilustras/odontomovel.png"} />
                <p className="text_icon">ODONTOMÓVEL<br/>PARA AÇÕES<br/>PREVENTIVAS</p>
              </Col>
            </Row>
          </div>

          <Link to={urlBase.client+"parasuaempresa"} >
            <div className="button_component_every"><span>CONTRATE AGORA</span></div>
          </Link>
        </Container>

        <Dialog
          open={this.state.modal1}
          onRequestClose={this.modalOff1.bind(this)}
          title={
            <div>
              <i
                id="form_client_close_modal"
                className="fas fa-times-circle color_fa"
                onClick={this.modalOff1.bind(this)}
              >{''}</i>
              <p className="form_p_client">DENTISTAS COM HORA MARCADA</p>
            </div>
          }
          contentStyle={{minWidth: '49%', borderRadius: 12}}
        >
          <div>
            <div className="margin_modal">
              <p className="text_modal_every3">Usabilidade é o nosso sobrenome.</p>
              <p className="text_modal_every2">
                Para usar o plano da Dental você só precisa seguir três passos:<br/>
                1. Escolher o profissional desejado;<br/>
                2. Ligar para marcar o horário;<br/>
                3. Comparecer à consulta.<br/>
              </p>
              <p className="text_modal_every2">Isso mesmo, <span className="text_modal_every3">sem complicação e otimizando seu tempo.</span></p>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={this.state.modal2}
          onRequestClose={this.modalOff2.bind(this)}
          title={
            <div>
              <i
                id="form_client_close_modal"
                className="fas fa-times-circle color_fa"
                onClick={this.modalOff2.bind(this)}
              >{''}</i>
              <p className="form_p_client">LIBERAÇÃO DE PROCEDIMENTOS VIA INTERNET</p>
            </div>
          }
          contentStyle={{minWidth: '49%', borderRadius: 12}}
        >
          <div>
            <div className="margin_modal">
              <p className="text_modal_every2">
                Todos os procedimentos são liberados sem necessidade de perícia ou<br/>
                deslocamento para obtenção de guias autorizadas.<br/>
              </p>
              <p className="text_modal_every2">Praticidade? <span className="text_modal_every3">Na Dental tem.</span></p>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={this.state.modal3}
          onRequestClose={this.modalOff3.bind(this)}
          title={
            <div>
              <i
                id="form_client_close_modal"
                className="fas fa-times-circle color_fa"
                onClick={this.modalOff3.bind(this)}
              >{''}</i>
              <p className="form_p_client">MATERIAIS DE QUALIDADE INTERNACIONAL</p>
            </div>
          }
          contentStyle={{minWidth: '49%', borderRadius: 12}}
        >
          <div>
            <div className="margin_modal">
              <p className="text_modal_every2">Os melhores entre os melhores, é assim que fazemos nossa rede credenciada.</p>
              <p className="text_modal_every2">
                Ambientes confortáveis, equipamentos modernos, materiais com padrão<br/>
                internacional e liberação direta de procedimentos.<br/>
              </p>
              <p className="text_modal_every3">Só a Dental oferece odontologia de classe mundial.</p>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={this.state.modal4}
          onRequestClose={this.modalOff4.bind(this)}
          title={
            <div>
              <i
                id="form_client_close_modal"
                className="fas fa-times-circle color_fa"
                onClick={this.modalOff4.bind(this)}
              >{''}</i>
              <p className="form_p_client">GERENTE DE CONTAS EMPRESARIAIS</p>
            </div>
          }
          contentStyle={{minWidth: '49%', borderRadius: 12}}
        >
          <div>
            <div className="margin_modal">
              <p className="text_modal_every3">Temos alguém especializado e pronto pra servir sua empresa.</p>
              <p className="text_modal_every2">
                O gestor de contas empresariais pode te ajudar a fazer movimentação cadastrais,<br/>
                emitir cartões digitais e sua fatura, acessar extratos de utilização dos serviços e<br/>
                muito mais.<br/>
              </p>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={this.state.modal5}
          onRequestClose={this.modalOff5.bind(this)}
          title={
            <div>
              <i
                id="form_client_close_modal"
                className="fas fa-times-circle color_fa"
                onClick={this.modalOff5.bind(this)}
              >{''}</i>
              <p className="form_p_client">GESTÃO DO BENEFÍCIO 100% ONLINE</p>
            </div>
          }
          contentStyle={{minWidth: '49%', borderRadius: 12}}
        >
          <div>
            <div className="margin_modal">
              <p className="text_modal_every2">
                A Dental disponibiliza três importantes canais para acessar serviços, a qualquer<br/>
                hora e em qualquer lugar.<br/>
              </p>
              <p className="text_modal_every3">
                Gestor online: <span className="text_modal_every2">Autoatendimento 24hs;</span><br/>
                Aplicativo Dental Center Associado: <span className="text_modal_every2">Serviços na palma da mão;</span><br/>
                Canal de WhatsApp: <span className="text_modal_every2">Tenha serviços e tire dúvidas com seu gestor de contas;</span><br/>
              </p>
              <p className="text_modal_every2">
                Nosso plano vai além das coberturas para garantir <span className="text_modal_every3">
                 conexão total com a sua empresa.
                </span>
              </p>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={this.state.modal6}
          onRequestClose={this.modalOff6.bind(this)}
          title={
            <div>
              <i
                id="form_client_close_modal"
                className="fas fa-times-circle color_fa"
                onClick={this.modalOff6.bind(this)}
              >{''}</i>
              <p className="form_p_client">ODONTOMÓVEL PARA AÇÕES PREVENTIVAS</p>
            </div>
          }
          contentStyle={{minWidth: '49%', borderRadius: 12}}
        >
          <div>
            <div className="margin_modal">
              <p className="text_modal_every3">Não esperamos, nós vamos até sua empresa.</p>
              <p className="text_modal_every2">
                Levamos saúde bucal ao local de trabalho, através de uma equipe de profissionais<br/>
                altamente capacitados e uma unidade móvel aparelhada com equipamentos e<br/>
                materiais de qualidade comprovada.<br/>
              </p>
            </div>
          </div>
        </Dialog>
      </div>
    );

  }

}

export default EveryCompany;



/** WEBPACK FOOTER **
 ** ./src/components/HomePageNew/EveryCompany.js
 **/